export default {
    products: []
}